<template>
  <div>
    <div>
      <el-row>
        <el-col>
          <el-row>
            <el-col :span="24" class="m-b-20">
              <el-radio-group v-model="progress_name" @change="searchTrackCodeByPhoneNumberOrderBy()">
                <el-row>
                  <el-col v-if="createdUser" :xl="4" :lg="6" :md="8" :sm="22" :xs="22" class="m-l-20 m-b-5 m-t-10">
                    <el-badge :value="this.createdUser" class="item w-100">
                      <el-radio-button label="100" class="w-100">Хэрэглэгч бүртгэсэн</el-radio-button>
                    </el-badge>
                  </el-col>
                  <el-col v-if="ereenAguulah" :xl="6" :lg="6" :md="8" :sm="22" :xs="22" class="m-l-20 m-b-5 m-t-10">
                    <el-badge :value="this.ereenAguulah" class="item w-100">
                      <el-radio-button label="110" class="w-100">Эрээн дах агуулах хүлээн авсан</el-radio-button>
                    </el-badge>
                  </el-col>
                  <el-col v-if="mongolSalbar" :xl="6" :lg="6" :md="8" :sm="22" :xs="22" class="m-l-20 m-b-5 m-t-10">
                    <el-badge :value="this.mongolSalbar" class="item w-100">
                      <el-radio-button label="120" class="w-100">Монгол дах салбар хүлээн авсан</el-radio-button>
                    </el-badge>
                  </el-col>
                  <el-col v-if="hvrgelteerAwna" :xl="5" :lg="6" :md="8" :sm="22" :xs="22" class="m-l-20 m-b-5 m-t-10">
                    <el-badge :value="this.hvrgelteerAwna" class="item w-100">
                      <el-radio-button label="130" class="w-100">Хэрэглэгч хүргэлтээр авна</el-radio-button>
                    </el-badge>
                  </el-col>
                  <el-col v-if="salbaraasOchijAwna" :xl="5" :lg="6" :md="8" :sm="22" :xs="22" class="m-l-20 m-b-5 m-t-10">
                    <el-badge :value="this.salbaraasOchijAwna" class="item w-100">
                      <el-radio-button label="140" class="w-100">Хэрэглэгч салбараас очиж авна</el-radio-button>
                    </el-badge>
                  </el-col>
                  <el-col v-if="hadgaluulna" :xl="5" :lg="6" :md="8" :sm="22" :xs="22" class="m-l-20 m-b-5 m-t-10">
                    <el-badge :value="this.hadgaluulna" class="item w-100">
                      <el-radio-button label="150" class="w-100">Хэрэглэгч салбар дээр хадгалуулна</el-radio-button>
                    </el-badge>
                  </el-col>
                  <el-col v-if="salbartUldsen" :xl="5" :lg="6" :md="8" :sm="22" :xs="22" class="m-l-20 m-b-5 m-t-10">
                    <el-badge :value="this.salbartUldsen" class="item w-100">
                      <el-radio-button label="170" class="w-100">Ачаа салбар дээр үлдсэн</el-radio-button>
                    </el-badge>
                  </el-col>
                  <el-col v-if="huleenAwsan" :xl="2" :lg="6" :md="8" :sm="22" :xs="22" class="m-l-20 m-b-5 m-t-10">
                    <el-badge :value="this.huleenAwsan" class="item w-100">
                      <el-radio-button label="200" class="w-100">Хэрэглэгч хүлээн авсан</el-radio-button>
                    </el-badge>
                  </el-col>
                  <el-col v-if="checkTrackCode" :xl="2" :lg="6" :md="8" :sm="22" :xs="22" class="m-l-20 m-b-5 m-t-10">
                    <el-badge :value="this.checkTrackCode" class="item w-100">
                      <el-radio-button label="180" class="w-100">Трак код шалгуулах</el-radio-button>
                    </el-badge>
                  </el-col>
                  <el-col v-if="cancelTrackCode" :xl="2" :lg="6" :md="8" :sm="22" :xs="22" class="m-l-20 m-b-5 m-t-10">
                    <el-badge :value="this.cancelTrackCode" class="item w-100">
                      <el-radio-button label="190" class="w-100">Цуцалсан</el-radio-button>
                    </el-badge>
                  </el-col>
                </el-row>
            </el-radio-group>
            </el-col>
            <el-col>
              <div v-if="this.progress_code === '120' || this.progress_code === '170'">
                <el-button :disabled="isDisable()" class="w-100 m-t-5" type="warning" size="small" @click="openHvrgeltDialog(130)">Хүргэлтээр авах</el-button>
                <div>
                  <el-button class="w-100 m-t-5" type="danger" size="small" @click="openOchijAvahDialog(140)">Очиж авна</el-button>
                </div>
                <el-button class="w-100 m-t-5" type="success" size="small" @click="openHadgaluulahDialog(150)">Хадгалуулах</el-button>
              </div>
            </el-col>
            <hr>
          </el-row><br>
        </el-col>
        <div v-if="orderList.length">
          <el-col class="m-b-10" v-if="this.progress_code === '120' || this.progress_code === '170'">
            <el-checkbox @change="checkAll()">Бүгдийг сонгоx</el-checkbox>
          </el-col>
          <el-col :span="8" v-if="this.progress_code === '120' || this.progress_code === '170'">
            Үнэ: {{ this.totalPrice | formatCurrency }}
          </el-col>
          <el-col :span="12" v-if="this.progress_code === '120' || this.progress_code === '170'">
            <span v-if="this.save_price != 0">Хадгалалт: {{ this.save_price | formatCurrency }}</span>
          </el-col>
          <el-col :span="4" class="m-b-10" v-if="this.progress_code === '120' || this.progress_code === '170'">
            Тоо: {{this.countTrackCode}}
          </el-col>
          <el-col>
            <div class="warning_text m-b-20" v-if="progress_name === '130'">
              Таны хүргэлтийн захиалга тухайн ажлын өдрийн 15:00 цагаас өмнө захиалсан хүргэлтийн нийт төлбөр 16:00 цагаас өмнө төлөгдсөн тохиолдолд салбараас ачааг бэлдэж хүргэлтийн компанид хүлээлгэн өгнө. Хүргэлтийн компани ачааг хүлээн авснаас хойш 24-48 цагийн дотор хэрэглэгчийн заасан хаягт хүргэхийг анхаарна уу.
            </div>
          </el-col>
          <el-col v-for="(item, index) in orderList" :key="`order-card-${item.id || index}`" :value="item.id">
            <el-card v-if="progress_name !== '130'" style="border-radius: 20px; margin-bottom: 5px;" shadow="hover">
              <!-- <div>
                <p class="bold_text">{{ item.track_code }}</p>
              </div> -->
              <div>
                <el-checkbox class="bold_text" :label="item.track_code" v-model="selectedTrackCodes" multiple filterable allow-create default-first-option @change="handlePrice()"></el-checkbox>
                <el-button @click="copyToClipboard(item.track_code)" type="text" :style="{ color: isCopied ? 'green' : 'black' }" :icon="isCopied === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
              </div>
              <div @click="getTrackCodeByCode(item)" class="cursor">
                <el-row>
                  <el-col :span="24">
                    <el-tag class="flr" size="small">{{ returnStatusValue(item.progress_code) }}
                  </el-tag>
                  </el-col>
                  <el-col :span="24">
                    <div class="font_size m-t-10 flr">
                      <span>Төлбөр:&nbsp; {{ item.price | formatCurrency() }}</span>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="font_size m-t-10">
                      <span>Төлөвийн огноо:&nbsp;{{ formatDate(item.progress_created_at) }}</span>
                    </div>
                  </el-col>
                  <el-col :span="24" v-if="item.save_price && item.save_price != 0">
                    <div class="font_size m-t-10">
                      <span>Хадгалалтын төлбөр:&nbsp; {{ item.save_price | formatCurrency() }}</span>
                    </div>
                  </el-col>
                  <el-col :span="24" v-if="item.description">
                    <div class="font_size m-t-10">
                      <span>Тайлбар:&nbsp;{{ item.description }}</span>
                    </div>
                  </el-col>
                  <el-col :span="24" v-if="item.irsen_salbariin_ner">
                    <div class="font_size m-t-10">
                    <span>Ачаа ирсэн салбар:&nbsp; {{ item.irsen_salbariin_ner }}</span>
                    </div>
                  </el-col>
                  <el-col :span="24" v-if="item.start_date">
                    <div class="font_size m-t-10">
                    <span>Хадгалж эхлэх огноо:&nbsp; {{ formatDate(item.start_date) }}</span>
                    </div>
                  </el-col>
                  <el-col :span="24" v-if="item.end_date">
                    <div class="font_size m-t-10">
                    <span>Хадгалж дуусах огноо:&nbsp; {{ formatDate(item.end_date) }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <el-row>
                <el-col class="m-t-10" v-if="item.progress_code === 100">
                  <el-button class="w-100 border_radius" size="small" type="danger" @click="deleteTrackCode(item)">Устгах</el-button>
                </el-col>
                <el-col class="m-t-10" v-if="item.progress_code === 100 || item.progress_code === 110" >
                  <el-button class="w-100 border_radius" size="small" type="warning" @click="checkTrackCodeDialogOpen(item)">Трак код шалгуулах</el-button>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col v-for="(item, index) in orderList" :key="`delivery-card-${item.id || index}`" :value="item.id">
            <el-card v-if="progress_name === '130'" class="m-b-10">
              <el-row>
                <el-col v-if="item.createdAt">
                  Төлөвийн огноо: {{ formatDate(item.createdAt) }}
                </el-col>
                <el-col v-if="item.Address && item.Address.detail_address">
                  Хүргүүлэх хаяг: {{ item.Address.detail_address }}
                </el-col>
                <el-col v-if="item.delivery_price">
                  Хүргэлтийн үнэ: {{ item.delivery_price | formatCurrency() }}
                </el-col>
                <el-col v-if="item.DeliveryDetail">
                  <div>Нийт хадгалалтын үнэ: {{ totalStorageFee(item) | formatCurrency }}</div>
                </el-col>
                <el-col v-if=" item.track_code_amount">
                  Ачааны үнэ: {{ item.track_code_amount | formatCurrency() }}
                </el-col>
                <el-col v-if="item.track_code_amount && item.delivery_price">
                  <b>Нийт үнэ: {{ item.track_code_amount + item.delivery_price + totalStorageFee(item) | formatCurrency() }}</b>
                </el-col>
                <el-col v-if=" item.ner">
                  Данс эзэмшигч: {{ item.ner}}
                </el-col>
                <el-col v-if=" item.dans">
                  Данс: {{ item.dans}}
                  <el-button @click="copyToClipboardDansHvrgelt(item.dans)"  class="font_size_10" type="text" :style="{ color: isCopiedDansHvrgelt ? 'green' : 'black' }" :icon="isCopiedDansHvrgelt === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
                </el-col>
                <el-col>
                  Трак код:
                  <div v-for="items,index in item.DeliveryDetail" :key="index" class="m-t-5 m-b-5">
                    <el-tag v-if="item.DeliveryDetail && items.TrackCode.track_code">{{ items.TrackCode.track_code }}</el-tag>
                    <div style="font-size: 10px;">
                      <p v-if="item.DeliveryDetail && items.TrackCode.jin && !items.TrackCode.urt">Жин: {{ items.TrackCode.jin }}гр</p>
                      <p v-if="item.DeliveryDetail && items.TrackCode.jin && items.TrackCode.urt && items.TrackCode.urgun">Жин: {{ items.TrackCode.jin }}кг</p>
                      <p v-if="item.DeliveryDetail && items.TrackCode.urt">Урт: {{ items.TrackCode.urt }}см</p>
                      <p v-if="item.DeliveryDetail && items.TrackCode.undur">Өндөр: {{ items.TrackCode.undur }}см</p>
                      <p v-if="item.DeliveryDetail && items.TrackCode.urgun">Өргөн: {{ items.TrackCode.urgun }}см</p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </div>
        <div class="m-l-5" v-else>Уучлаарай энэ төлөв дээр бараа байхгүй байна.</div>
        <OrderDetailDialog v-if="this.$root.orderDetailDialog" :orderDetailProp="selectOrder" :cuponPrice="this.cupon_price"/>
        <CheckTrackCode v-if="this.$root.checkTrackCode" :orderDetailProp="selectOrder"/>
      </el-row>
      <el-dialog :visible.sync="this.hvrgeltDialog" width="90%" :before-close="handleCloseHvrgeltDialog" center title="Хүргэлтийн захиалга">
        <div>
          <div class="m-b-10">
            Хүргэлтээр авах трак кодын жагсаалт<br><br>
            <el-tag v-for="item,index in selectedTrackCodes" :key="index" class="m-r-10">{{item}}</el-tag>
          </div>
          <hr>
          <el-col :span="24" v-if="this.progress_code === '120' || this.progress_code === '170'">
            Трак кодуудын нийт үнэ: {{this.totalPrice | formatCurrency }}
          </el-col>
          <el-col :span="24" v-if="this.progress_code === '120' || this.progress_code === '170'">
            <span v-if="this.save_price != 0">Хадгалалтын үнэ: {{this.save_price | formatCurrency }}</span>
          </el-col>
          <el-col :span="24" class="m-b-10" v-if="this.progress_code === '120' || this.progress_code === '170'">
            Тоо: {{this.countTrackCode}}
          </el-col>
          <hr>
          <!-- <u>Та хүргэлтээр авах огноо болон цагаа сонгоно уу!</u><br><br>
          <div class="m-b-20">
            <el-date-picker v-model="hvrgvvlehOgnoo" type="datetime" placeholder="Огноо, цаг оруулах"></el-date-picker>
          </div> -->
          <div class="m-b-10">
            Таны хаягийн жагсаалт /сонгох/
          </div>
          <div class="m-b-5">
            <div class="p-b-20">
              <el-radio-group class="vertical-radio-group" v-model="address_id">
                <el-radio-button v-for="item,index in addressList" :key="index" :label="item.id" :value="item.id" style="margin: 5px;" class="selected-address">
                  {{ item.nick_name }}
                </el-radio-button>
            </el-radio-group>
              </div>
          </div>
          <el-row>
            <el-col>
              <hr>
              <!-- buhiin urguu hvrgelt -->
              <el-card class="m-b-10" v-if="showBuhiinAccountCard">
                <el-tag class="m-b-10">Бөхийн өргөө</el-tag>
                <div class="m-b-10">
                  <b>Ачааны үнэ : {{ this.totalPrice | formatCurrency() }}</b>
                </div>
                <div class="m-b-10">
                  <b>Хүргэлтийн үнэ : {{ deliveryPriceNiitBuhiinUrguu | formatCurrency() }}</b>
                </div>
                <div class="m-b-10" v-if="this.save_price != 0">
                  <b>Хадгалалтын үнэ : {{ this.save_price | formatCurrency() }}</b>
                </div>
                <div class="m-b-10" v-if="cupon_price">
                  <b style="color: green;">Хөнгөлөлтийн үнэ: {{ cupon_price | formatCurrency()}}</b>
                </div>
                <div class="m-b-10">
                  <b>Нийт төлөх үнэ : {{ (Number(buhiinUrguuAmount) || 0) + (Number(deliveryPriceNiitBuhiinUrguu) || 0) - (Number(cupon_price) || 0) + (Number(save_price) || 0) | formatCurrency() }}</b>
                </div>
                <span class="font_size_10">
                  <div>Банк : Хаан банк</div>
                  <div>Дансны дугаар : MN 89000500 5402587325
                    <el-button @click="copyToClipboardDans('MN890005005402587325')"  class="font_size_10" type="text" :style="{ color: isCopiedDans ? 'green' : 'black' }" :icon="isCopiedDans === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
                  </div>
                  <div>Дансны эзэмшигч : Ж. Саруултуяа</div>
                  <div>Гүйлгээний утга : {{ phone_number }}
                    <el-button @click="copyToClipboard(phone_number)"  class="font_size_10" type="text" :style="{ color: isCopied ? 'green' : 'black' }" :icon="isCopied === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
                  </div>
                </span>
                <p class="no-wrap font_size_10 color-red" style="text-align: center;">Та төлбөрөө төлсөн тохиолдолд салбараас таны ачааг бэлдэж хүргэлтэнд гаргана.</p>
              </el-card>
              <!-- officer hvrgelt -->
              <el-card class="m-b-10" v-if="showOfficerAccountCard">
                <el-tag class="m-b-10">Оффицер</el-tag>
                <div class="m-b-10">
                  <b>Хүргэлтийн үнэ : {{ deliveryPriceNiitOfficer | formatCurrency() }}</b>
                </div>
                <div class="m-b-10">
                  <b>Хадгалалтын үнэ : {{ this.save_price | formatCurrency() }}</b>
                </div>
                <div class="m-b-10" v-if="this.save_price != 0">
                  <b>Хадгалалтын үнэ : {{ this.save_price | formatCurrency() }}</b>
                </div>
                <div class="m-b-10" v-if="cupon_price">
                  <b style="color: green;">Хөнгөлөлтийн үнэ: {{ cupon_price | formatCurrency()}}</b>
                </div>
                <div class="m-b-10">
                  <b>Нийт төлөх үнэ : {{ (Number(officerAmount) || 0) + (Number(deliveryPriceNiitOfficer) || 0) - (Number(cupon_price) || 0) + (Number(save_price) || 0) | formatCurrency() }}</b>
                </div>
                <span class="font_size_10">
                  <div>Банк : Хаан банк</div>
                  <div>Дансны дугаар : MN890005005402587325
                    <el-button @click="copyToClipboardDans('MN890005005402587325')"  class="font_size_10" type="text" :style="{ color: isCopiedDans ? 'green' : 'black' }" :icon="isCopiedDans === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
                  </div>
                  <div>Дансны эзэмшигч : Ж. Саруултуяа</div>
                  <div>Гүйлгээний утга : {{ phone_number }}
                    <el-button @click="copyToClipboard(phone_number)"  class="font_size_10" type="text" :style="{ color: isCopied ? 'green' : 'black' }" :icon="isCopied === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
                  </div>
                </span>
                <p class="no-wrap font_size_10 color-red" style="text-align: center;">Та төлбөрөө төлсөн тохиолдолд салбараас таны ачааг бэлдэж хүргэлтэнд гаргана.</p>
              </el-card>
              <hr>
            </el-col>
            <el-col>
            </el-col>
            <el-col :span="24" class="m-b-10">
              <el-button class="w-100" type="success" size="small" @click="createTrackCodesAndProgress()">Хадгалах</el-button>
            </el-col>
            <el-col :span="24">
              <el-button class="w-100" type="primary" size="small" @click="addAddress()">Хаяг нэмэх</el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="this.hadgaluulahDialog" width="90%" :before-close="handleCloseHadgaluulahDialog" center title="Хадгалуулах захиалга">
        <div>
          <div class="m-b-10">
            Хадгалуулах трак кодын жагсаалт<br><br>
            <el-tag v-for="item, index in selectedTrackCodes" :key="index" class="m-r-10">{{ item }}</el-tag>
          </div>
          <div>
            <div class="m-b-20">
              <span class="demonstration">Хадгалуулж эхлэх огноо: </span>
              <el-date-picker v-model="startDate" type="date" placeholder="Сонгоно уу"></el-date-picker>
            </div>
            <div class="m-b-20">
              <span class="demonstration">Хадгалуулж дуусах огноо: </span>
              <el-date-picker v-model="endDate" type="date" placeholder="Сонгоно уу"></el-date-picker>
            </div>
            <el-button type="success" size="small" @click="createTrackCodesAndProgress()">Хадгалах</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="this.ochijAvahDialog" width="90%" :before-close="handleCloseOchijAvahtDialog" center title="Салбараас очиж авах захиалга">
        <div class="m-b-10">
          Салбараас очиж авах трак код<br><br>
          <el-tag v-for="item, index in selectedTrackCodes" :key="index" class="m-r-10">{{ item }}</el-tag>
        </div>
        <div class="m-b-20">
          <span class="demonstration">Очиж авах огноо, цаг: </span><br><br/>
          <el-date-picker v-model="avahOgnoo" type="datetime" placeholder="Оруулна уу" class="m-b-10"></el-date-picker>
        </div>
        <el-card class="m-b-10" v-if="buhiinUrguuAmount">
          <el-tag class="m-b-10">Бөхийн өргөө салбараас авах ачаа</el-tag>
          <div class="m-b-10">
            <b v-if="cupon_price">Хөнгөлөлттийн үнэ: {{ cupon_price }}</b>
          </div>
          <div class="m-b-10">
            <b v-if="this.save_price">Хадгалалтын үнэ: {{ this.save_price }}</b>
          </div>
          <div class="m-b-10" v-if="cupon_price">
            <b style="color: green;">Хөнгөлөлтийн үнэ: {{ cupon_price | formatCurrency()}}</b>
          </div>
          <div class="m-b-10">
            <b>Нийт төлөх үнэ : {{ buhiinUrguuAmount - cupon_price + save_price | formatCurrency() }}</b>
          </div>
          <!-- <span class="font_size_10">
            <div>Банк : Хаан банк</div>
            <div>Дансны дугаар : MN 72000500 5039930627
              <el-button @click="copyToClipboardDans(MN720005005039930627 )"  class="font_size_10" type="text" :style="{ color: isCopiedDans ? 'green' : 'black' }" :icon="isCopiedDans === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
            </div>
            <div>Дансны эзэмшигч : Б.Юмжир</div>
            <div>Гүйлгээний утга : {{ phone_number }}
              <el-button @click="copyToClipboard(phone_number)"  class="font_size_10" type="text" :style="{ color: isCopied ? 'green' : 'black' }" :icon="isCopied === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
            </div>
          </span> -->
          <p class="no-wrap font_size_10 color-red" style="text-align: center;">Та төлбөрөө төлсөн тохиолдолд салбараас таны ачааг бэлтгэж очиж авахад бэлэн болгоно.</p>
        </el-card>
        <el-card class="m-b-10" v-if="officerAmount">
          <el-tag class="m-b-10">Оффицер салбараас авах ачаа</el-tag>
          <div class="m-b-10">
            <b>Нийт үнэ : {{ officerAmount | formatCurrency() }}</b>
          </div>
          <!-- <span class="font_size_10">
            <div>Банк : Хаан банк</div>
            <div>Дансны дугаар : MN 86000500 5300542312
              <el-button @click="copyToClipboardDans(MN860005005300542312)"  class="font_size_10" type="text" :style="{ color: isCopiedDans ? 'green' : 'black' }" :icon="isCopiedDans === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
            </div>
            <div>Дансны эзэмшигч : Л.Пүрэв-Очир</div>
            <div>Гүйлгээний утга : {{ phone_number }}
              <el-button @click="copyToClipboard(phone_number)"  class="font_size_10" type="text" :style="{ color: isCopied ? 'green' : 'black' }" :icon="isCopied === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
            </div>
          </span> -->
          <p class="no-wrap font_size_10 color-red" style="text-align: center;">Та төлбөрөө төлсөн тохиолдолд салбараас таны ачааг бэлтгэж очиж авахад бэлэн болгоно.</p>
        </el-card>
          <el-button type="success" size="small" @click="createTrackCodesAndProgress()">Хадгалах</el-button>
      </el-dialog>
    </div>
    <div>
      <AddressAddDialog v-if="this.$root.addressAddDialog"/>
    </div>
  </div>
</template>

<script>
// import OrderListTab from './Dialog/orderListTab.vue'
import services from '@/helpers/services'
import OrderDetailDialog from './Dialog/orderDetailDialog.vue'
import AddressAddDialog from './Dialog/addressAddDialog.vue'
import CheckTrackCode from './Dialog/checkTrackCode.vue'
import {
  mapGetters
} from 'vuex'

export default {
  data () {
    return {
      selectOrder: {},
      checkedStatus: [],
      orderList: [],
      emptyValue: {},
      progress_code: null,
      orderListBefore: [],
      progress_name: 100,
      selectedTrackCodes: [],
      isIndeterminate: true,
      // showCheckbox: false,
      hvrgeltDialog: false,
      hadgaluulahDialog: false,
      addressList: [],
      progress: null,
      address_id: null,
      startDate: null,
      endDate: null,
      totalPrice: 0,
      countTrackCode: 0,
      createdUser: 0,
      ereenAguulah: 0,
      mongolSalbar: 0,
      salbartUldsen: 0,
      huleenAwsan: 0,
      isCopied: false,
      hvrgelteerAwna: 0,
      salbaraasOchijAwna: 0,
      hadgaluulna: 0,
      hvrgvvlehOgnoo: null,
      delivery: [],
      buhiinUrguuAmount: null,
      officerAmount: null,
      isCopiedDans: false,
      phone_number: null,
      ochijAvahDialog: false,
      avahOgnoo: null,
      deliveryAmount: 0,
      deliveryPriceNiitBuhiinUrguu: 0,
      deliveryPriceNiitOfficer: 0,
      phoneNumber: null,
      cupon_price: 0,
      checkTrackCode: 0,
      cancelTrackCode: 0,
      dans: null,
      ner: null,
      isCopiedDansHvrgelt: false,
      save_price: 0
    }
  },
  props: {
    trackCodesList: Array,
    trackCodeDetailProp: Object
  },
  components: {
    OrderDetailDialog,
    AddressAddDialog,
    CheckTrackCode
  },
  computed: {
    ...mapGetters([
      'userDetailGetter'
    ]),
    selectedBranchCodes () {
      const selected = new Set(this.selectedTrackCodes)
      const codes = new Set()
      this.orderList.forEach(item => {
        if (selected.has(item.track_code)) {
          let branchCode = Number(item.irsen_salbar)
          if (Number.isNaN(branchCode) && item.irsen_salbariin_ner) {
            const branchName = String(item.irsen_salbariin_ner).toLowerCase()
            if (branchName.includes('бөх')) branchCode = 1
            if (branchName.includes('оффицер') || branchName.includes('офицер') || branchName.includes('officer')) branchCode = 2
          }
          if (!Number.isNaN(branchCode)) {
            codes.add(branchCode)
          }
        }
      })
      return Array.from(codes)
    },
    showBuhiinAccountCard () {
      return this.selectedBranchCodes.includes(1)
    },
    showOfficerAccountCard () {
      return this.selectedBranchCodes.includes(2)
    }
  },
  watch: {
    '$root.addressAddDialog': function (newVal) {
      if (!newVal) {
        this.viewAddress()
      }
    }
  },
  created () {
    this.searchTrackCodeByPhoneNumberOrderBy()
    this.trackCodeCountByPhone()
  },
  methods: {
    formatDate (value) {
      if (!value || typeof value !== 'string') return '-'
      return value.includes('T') ? value.split('T')[0] : value
    },
    totalStorageFee (order) {
      this.save_price = 0
      return order.DeliveryDetail.reduce((sum, detail) => {
        return sum + (detail.TrackCode?.save_price || 0)
      }, 0)
    },
    checkTrackCodeDialogOpen (data) {
      this.selectOrder = data
      this.$root.checkTrackCode = true
    },
    handleCloseOchijAvahtDialog () {
      this.ochijAvahDialog = false
    },
    openOchijAvahDialog (data) {
      this.ochijAvahDialog = true
      this.progress_code = data
      this.progress = data
      this.ochijAvahPrice()
    },
    async copyToClipboard (text) {
      try {
        await navigator.clipboard.writeText(text)
        this.isCopied = true
        setTimeout(() => {
          this.isCopied = false
        }, 1000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    },
    async copyToClipboardDans (text) {
      try {
        await navigator.clipboard.writeText(text)
        this.isCopiedDans = true
        setTimeout(() => {
          this.isCopiedDans = false
        }, 1000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    },
    async copyToClipboardDansHvrgelt (text) {
      try {
        await navigator.clipboard.writeText(text)
        this.isCopiedDansHvrgelt = true
        setTimeout(() => {
          this.isCopiedDansHvrgelt = false
        }, 1000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    },
    checkAll () {
      if (this.selectedTrackCodes.length === this.orderList.length) {
        this.selectedTrackCodes = []
      } else {
        this.selectedTrackCodes = this.orderList.map(item => item.track_code)
      }
      this.handlePrice()
    },
    handlePrice () {
      this.totalPrice = 0
      this.countTrackCode = 0
      this.save_price = 0
      this.orderList.forEach(element => {
        this.selectedTrackCodes.forEach(elementTrackCode => {
          if (element.track_code === elementTrackCode) {
            this.totalPrice = element.price + this.totalPrice
            this.save_price = element.save_price + this.save_price
            this.countTrackCode++
          }
        })
      })
    },
    returnStatusValue (data) {
      const result = this.$root.statusArray.find(element => element.value === data)
      if (result) {
        return result.label
      } else {
        return 'empty'
      }
    },
    getTrackCodeByPhoneNumberOrderByAll () {
      try {
        this.$root.fullscreenLoading = true
        // const phoneNumber = this.userDetailGetter.phone1
        // if (!phoneNumber) {
        //   this.$root.fullscreenLoading = false
        //   return
        // }
        console.log(this.userDetailGetter.phone1)
        const phone = this.userDetailGetter.phone1
        services.getTrackCodeByPhoneNumberOrderByAll(phone)
          .then((response) => {
            if (response.type === 'success') {
              this.orderListBefore = response.data
              this.orderList = response.data
            } else if (response.type === 'empty') {
              this.orderList = response.data
              this.emptyValue = 'Хоосон'
            }
            this.$root.fullscreenLoading = false
          })
          .catch((error) => {
            console.error('Алдаа:', error.message)
            this.emptyValue = error.message
            this.$root.fullscreenLoading = false
          })
      } catch (error) {
        console.error('Алдаа:', error.message)
      }
    },
    searchTrackCodeByPhoneNumberOrderBy () {
      try {
        this.progress_code = this.progress_name
        this.$root.fullscreenLoading = true
        const phoneNumber = this.userDetailGetter.phone1
        if (!phoneNumber) {
          this.$root.fullscreenLoading = false
          return
        }
        if (this.progress_name !== '130') {
          services.searchTrackCodeByPhoneNumberOrderBy(phoneNumber, this.progress_name)
            .then((response) => {
              if (response.type === 'success') {
                if (this.progress_name == null) {
                  this.orderListBefore = response.data
                } else {
                  this.orderList = response.data
                }
              } else if (response.type === 'empty') {
                this.orderList = response.data
                this.emptyValue = 'Хоосон'
              }
              this.$root.fullscreenLoading = false
            })
            .catch((error) => {
              console.error('Алдаа:', error.message)
              this.emptyValue = error.message
              this.$root.fullscreenLoading = false
            })
        } else if (this.progress_name === '130') {
          const payload = { searchQuery: phoneNumber, progress_code: this.progress_name }
          services.getHvrgelt(payload)
            .then((response) => {
              if (response.type === 'success') {
                if (this.progress_name == null) {
                  this.orderListBefore = response.data
                } else {
                  this.orderList = response.data
                }
              } else if (response.type === 'empty') {
                this.orderList = response.data
                this.emptyValue = 'Хоосон'
              }
              this.$root.fullscreenLoading = false
            })
            .catch((error) => {
              console.error('Алдаа:', error.message)
              this.emptyValue = error.message
              this.$root.fullscreenLoading = false
            })
        }
      } catch (error) {
        console.error('Алдаа:', error.message)
      }
    },
    groupAndCountByProgressCode () {
      const groupedCounts = {}

      // JSON өгөгдлөөс progress_code-г тоолох
      this.orderListBefore.forEach(item => {
        if (item.Progress && Array.isArray(item.Progress)) {
          item.Progress.forEach(progress => {
            const code = progress.progress_code
            if (code !== null && code !== undefined) {
              groupedCounts[code] = (groupedCounts[code] || 0) + 1
            }
          })
        }
      })
      console.log(groupedCounts, 'arrr')

      // statusArray-г ашиглан нэртэй үр дүн үүсгэх
      const resultWithLabels = this.$root.statusArray.map(status => {
        const value = groupedCounts[status.value] || 0
        if (value === 0) return null // 0-той тэнцүү бол буцаахгүй
        return {
          label: status.label,
          value,
          progress_code: status.value
        }
      }).filter(Boolean)

      return resultWithLabels
    },
    changeValue (data) {
      this.progress_code = data
      this.searchTrackCodeByPhoneNumberOrderBy(this.progress_code)
    },
    async getTrackCodeByCode (data) {
      try {
        this.$root.fullscreenLoading = true
        const response = await services.getTrackCodeByCode(data.track_code)
        if (response.type === 'success') {
          this.selectOrder = response.data
          this.$root.fullscreenLoading = false
          this.$root.orderDetailDialog = true
        } else {
          this.$alert('Алдаа: Захиалгын мэдээллийг авахад алдаа гарлаа.', 'Алдаа', {
            confirmButtonText: 'Ойлголоо'
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.$root.fullscreenLoading = false
      }
    },
    handleCheckedCitiesChange (value) {
      this.selectedTrackCodes.push(value)
    },
    openHvrgeltDialog (data) {
      this.progress = data
      this.hvrgeltDialog = true
      this.deliveryPrice()
      this.ochijAvahPrice()
      this.viewAddress()
      // this.cuponPrice()
    },
    async cuponPrice () {
      try {
        this.phoneNumber = this.userDetailGetter.phone1
        const payload = { phone_number: this.phoneNumber, track_codes: this.selectedTrackCodes }
        const response = await services.cuponPrice(payload)
        if (response.type === 'success') {
          this.cupon_price = response.data
        }
      } catch (error) {
        console.log(error)
      }
    },
    async deliveryPrice () {
      try {
        this.phone_number = this.userDetailGetter.phone1
        const response = await services.deliveryPrice(this.selectedTrackCodes)
        if (response.type === 'success') {
          if (response.deliveryPriceJinBuhiinUrguu && response.deliveryPriceVBuhiinUrguu) {
            this.deliveryPriceNiitBuhiinUrguu = response.deliveryPriceJinBuhiinUrguu + response.deliveryPriceVBuhiinUrguu
          }
          if (response.deliveryPriceJinBuhiinUrguu) {
            this.deliveryPriceNiitBuhiinUrguu = response.deliveryPriceJinBuhiinUrguu
          }
          if (response.deliveryPriceVBuhiinUrguu) {
            this.deliveryPriceNiitBuhiinUrguu = response.deliveryPriceVBuhiinUrguu
          }
          if (response.deliveryPriceJinOfficer && response.deliveryPriceVOfficer) {
            this.deliveryPriceNiitOfficer = response.deliveryPriceJinOfficer + response.deliveryPriceVOfficer
          }
          if (response.deliveryPriceJinOfficer) {
            this.deliveryPriceNiitOfficer = response.deliveryPriceJinOfficer
          }
          if (response.deliveryPriceVOfficer) {
            this.deliveryPriceNiitOfficer = response.deliveryPriceVOfficer
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async ochijAvahPrice () {
      try {
        this.phone_number = this.userDetailGetter.phone1
        const response = await services.getOchijAvahPrice(this.selectedTrackCodes)
        if (response.type === 'success') {
          this.delivery = response.data
          this.buhiinUrguuAmount = response.buhiinUrguu
          this.officerAmount = response.officer
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleCloseHvrgeltDialog () {
      this.hvrgeltDialog = false
      this.address_id = null
    },
    openHadgaluulahDialog (data) {
      this.progress = data
      this.hadgaluulahDialog = true
    },
    handleCloseHadgaluulahDialog () {
      this.hadgaluulahDialog = false
      this.startDate = null
      this.endDate = null
    },
    viewAddress () {
      this.$root.fullscreenLoading = true
      services.viewAddress(this.userDetailGetter.id)
        .then((response) => {
          this.addressList = response.data
          this.$root.fullscreenLoading = false
        })
        .catch((error) => {
          console.error('Алдаа:', error.message)
          this.$root.fullscreenLoading = false
        })
    },
    async createTrackCodesAndProgress () {
      try {
        if (!this.selectedTrackCodes.length) {
          this.$notify({
            title: 'Уучлаарай',
            message: 'Та трак код сонгоогүй байна.',
            type: 'error'
          })
          return
        }
        if (this.address_id === null && this.progress === 130) {
          this.$notify({
            title: 'Уучлаарай',
            message: 'Та хүргүүлэх хаяг сонгоогүй байна.',
            type: 'error'
          })
          return
        }
        if (this.startDate === null && this.progress === 150) {
          this.$notify({
            title: 'Уучлаарай',
            message: 'Та хадгалуулж эхлэх огноо сонгоогүй байна.',
            type: 'error'
          })
          return
        }
        if (this.endDate === null && this.progress === 150) {
          this.$notify({
            title: 'Уучлаарай',
            message: 'Та хадгалуулж дуусах огноо сонгоогүй байна.',
            type: 'error'
          })
          return
        }
        if (this.avahOgnoo === null && this.progress === 140) {
          this.$notify({
            title: 'Уучлаарай',
            message: 'Та очиж авах огноо оруулаагүй байна байна.',
            type: 'error'
          })
          return
        }
        if (this.showBuhiinAccountCard && this.buhiinUrguuAmount && this.deliveryPriceNiitBuhiinUrguu) {
          this.deliveryAmount = this.buhiinUrguuAmount + this.deliveryPriceNiitBuhiinUrguu
        } else if (this.showOfficerAccountCard && this.officerAmount && this.deliveryPriceNiitOfficer) {
          this.deliveryAmount = this.officerAmount + this.deliveryPriceNiitOfficer
        }
        this.phoneNumber = this.userDetailGetter.phone1
        const trackCodeAmount = this.totalPrice
        if (this.showBuhiinAccountCard && !this.showOfficerAccountCard) {
          this.dans = 'MN890005005402587325'
          this.ner = 'Ж. Саруултуяа'
        } else if (this.showOfficerAccountCard && !this.showBuhiinAccountCard) {
          this.dans = 'MN890005005402587325'
          this.ner = 'Ж. Саруултуяа'
        } else {
          this.dans = null
          this.ner = null
        }
        this.$confirm('Та ачаа тээврийн болон хүргэлтийн төлбөрөө төлсөн тохиолдолд хүргэлт гарахыг анхаарна уу.', 'АНХААРУУЛГА', {
          confirmButtonText: 'Ойлголоо',
          cancelButtonText: 'Үгүй',
          type: 'warning'
        }).then(() => {
          this.$root.fullscreenLoading = true
          const payload = { track_code: this.selectedTrackCodes, progress_code: this.progress, address_id: this.address_id, start_date: this.startDate, end_date: this.endDate, hvrgvvleh_ognoo: this.hvrgvvlehOgnoo, ochij_avah_ognoo: this.avahOgnoo, phone_number: this.phoneNumber, delivery_amount: this.deliveryPriceNiitBuhiinUrguu + this.deliveryPriceNiitOfficer, track_code_amount: trackCodeAmount, dans: this.dans, ner: this.ner, save_price: this.save_price }
          services.createTrackCodesAndProgress(payload)
            .then((response) => {
              if (response.type === 'success') {
                this.$notify({
                  title: 'Амжилттай',
                  message: 'Захиалгийн төлөв амжилттай өөрчлөгдлөө',
                  type: 'success'
                })
                location.reload()
              } else if (response.type === 'unsuccess') {
                this.$notify({
                  title: 'Уучлаарай',
                  message: response.message,
                  type: 'error'
                })
              }
              this.$root.fullscreenLoading = false
            })
            .catch((error) => {
              console.error('Алдаа:', error.message)
              this.emptyValue = error.message
              this.$root.fullscreenLoading = false
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Хадгалах явц цуцлагдлаа'
          })
        })
      } catch (error) {
        console.error('Алдаа:', error.message)
      }
    },
    addAddress () {
      this.$root.addressAddDialog = true
    },
    isDisable () {
      if (!this.selectedTrackCodes.length) {
        return true
      }
    },
    handleSelectAll () {
      this.orderList.forEach(element => {
        this.selectedTrackCodes = element.track_code
      })
    },
    handleCheckAllChange (val) {
      this.selectedTrackCodes = val ? this.orderList.track_code : []
      this.isIndeterminate = false
    },
    deleteTrackCode (data) {
      this.$confirm('Та трак код устгахдаа итгэлтэй байна уу?.', 'Анхааруулга', {
        confirmButtonText: 'Тийм',
        cancelButtonText: 'Үгүй',
        center: true,
        type: 'error'
      }).then(() => {
        const payload = data.id
        services.deleteTrackCode(payload)
          .then((response) => {
            if (response.type === 'success') {
              this.$notify({
                title: 'Амжилттай',
                message: 'Трак код амжилттай устгагдлаа',
                type: 'success',
                duration: 3000
              })
              this.searchTrackCodeByPhoneNumberOrderBy(100)
            } else if (response.type === 'unsuccess') {
              this.$notify({
                title: 'Уучлаарай',
                message: response.message,
                type: 'error'
              })
            }
            this.$root.fullscreenLoading = false
          })
          .catch((error) => {
            console.error('Алдаа:', error.message)
            this.$root.fullscreenLoading = false
          })
      }).catch(() => {
      })
    },
    async trackCodeCountByPhone (data) {
      try {
        const phoneNumber = this.userDetailGetter.phone1
        const response = await services.trackCodeCountByPhone(phoneNumber)
        if (response.type === 'success') {
          this.createdUser = response.data.createdUser
          this.ereenAguulah = response.data.ereenAguulah
          this.mongolSalbar = response.data.mongolSalbar
          this.salbartUldsen = response.data.salbartUldsen
          this.hvrgelteerAwna = response.data.hvrgelteerAwna
          this.salbaraasOchijAwna = response.data.salbaraasOchijAwna
          this.hadgaluulna = response.data.hadgaluulna
          this.huleenAwsan = response.data.huleenAwsan
          this.checkTrackCode = response.data.checkTrackCode
          this.cancelTrackCode = response.data.cancelTrackCode
        } else {
          this.$alert('Алдаа: Захиалгын мэдээллийг авахад алдаа гарлаа.', 'Алдаа', {
            confirmButtonText: 'Ойлголоо'
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.$root.fullscreenLoading = false
      }
    }
  }
}
</script>

<style>
.m-b-10 {
  margin-bottom: 10px;
}
.width {
  width: 100% !important;
}
.font_size {
  font-size: 13px;
}
.vertical-radio-group {
  display: flex;
  flex-direction: column; /* Доошоо цувуулах */
  gap: 10px; /* Элементүүдийн хоорондын зай */
}
.border_radius {
  border-radius: 200px !important;
}
.warning_text {
  color: grey;
  font-size: 10px;
  line-height: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
